import forEach from 'lodash/forEach';
import uniq from "lodash/uniq";

import {QuotePricing} from 'shared_components';
import store from '../store';
import {getInstallationsTotalCost} from "../reducers/instReducer";
import {DISCOUNT_MAIN_TYPES, DISCOUNT_TYPES} from "../bvcomponents/priceWorksheet/discounstInterface";
import {checkIfInCatProperty} from "./displayLogic";
import {PartMenuType} from "../bvcomponents/visComponents/constants";
import {filterFeaturesByValues, isVisualizerRoute, s3FeatureImagePath, splitFeatureName} from "./utils";
import {getCountertopFeatureGroup, getCurrentLayout} from "../bvcomponents/appLayout";
import {
  featureIsMatchingQtCatName,
  getCurrentQuoteRoomCartItem,
} from "./categorySwitchingFunctions";
import {
  BACKSPLASH_LABELS,
  CABINET_BATHROOM_LABELS,
  CABINET_LABELS,
  CABINET_PART_IDS_WITH_HALF_PRICE,
  CORNER_LABELS,
  COUNTERTOP_LABELS,
  EDGE_LABELS,
  SQFT_FEATURES
} from "../bvcomponents/sqft/constants";
import sqftConfig from "../bvcomponents/sqft/components/canvas/store/sqftConfig";
import {mm2ToM2, sqInchesToSqFoot} from "../bvcomponents/sqft/helpers/sqftHelper";
import {getBundledFeatures, isInStock} from "../bvcomponents/look/lookNavigation/lookFunctions2";
import {LIXIL_USER_QUERY_PARAMS} from "../api/look-api";
import {CART_ITEM_ADDED_BY} from "../bvcomponents/shoppingCart/cartItemInterface";
import {ROUTES} from "../routes";
import {getCommonVisualizerType, IS_LIXIL_UI, IS_PRODUCT_JOURNEY} from "../config";
import {LOOK_WALLS_ONLY} from "../bvcomponents/look/core/constants";
import {getFeaturePriceProperty, numberWithCommas, updatePriceWithMarkUp} from "./priceFunctions";
import {isCabinetsFabricator, isCafeCountetops} from "./fabricatorHardcode";
import {getDifferentCurrencyCartItems} from "./misc2";
import {
  getCafeCountertopsDeliveryCost,
  getCartItemShippingCost
} from "../bvcomponents/look/grohe/groheCart/groheCartDelivery/deliveryFunctions";
import {
  discountSectionExistsInCurrentWizardSelections,
  shouldUseMultipleWorkSheets,
  getDiscountsForSection,
  getFilteredSections,
  shouldCalculateDiscount, getDiscountCurrentValue
} from "../bvcomponents/priceWorksheet/discountFunctions";
import {updatePriceWithFeatureMarkUp, updatePricingPresetsWithUseBaseLogic} from "./markUpFunctions";
import {QUANTITY_GROUP} from "../bvcomponents/sqft/components/canvas/store/workspaceControllers";
import {getCostcoShopCartCost} from "./otherPricingLogic/costcoFunctions";

export const featureThumbnailUrl = (feature, size) => {
  if (feature.menuType === PartMenuType.Complex) {
    return feature.partThumbnail
  }
  return feature.dbFeature.customThumbnail
    ? feature.dbFeature.customThumbnail
    : feature.dbFeature.thumbnailUrl
      ? s3FeatureImagePath(feature.dbFeature, size)
      : "";
}

export const getPartThemeThumbnail = (partThumbnail, activeTheme) => {
  if (partThumbnail && partThumbnail.includes("/images") && activeTheme && activeTheme !== "qc") {
    const splitted = partThumbnail.split("/images");
    if (splitted[0] && splitted[1]) {
      return splitted[0] + "/images-" + activeTheme + splitted[1];
    }
  }
  return partThumbnail
}

export const TAX_DISCOUNT_PCT = 25;

export const browserIsSafari = () => {
  return navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
    navigator.userAgent &&
    navigator.userAgent.indexOf('CriOS') === -1 &&
    navigator.userAgent.indexOf('FxiOS') === -1;
};
export const isIOSDevice = () => {
  return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
};
export const isChrome = () => {
  return !!navigator.userAgent.match('CriOS');
};
export const isIphoneX = () => { // https://stackoverflow.com/questions/47226824/iphonex-and-notch-detection
  let iPhone = /iPhone/.test(navigator.userAgent) && !window.MSStream;
  let aspect = window.screen.width / window.screen.height;
  return !!(iPhone && aspect.toFixed(3) === "0.462")
};
export const isAndroid = () => {
  return navigator.userAgent && navigator.userAgent.toLowerCase().indexOf("android") > -1;
};
export const isIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};
export const isIE = () => {
  return (window.navigator.userAgent.indexOf('MSIE ') > 0)
    || (!!window.MSInputMethodContext && !!document.documentMode)
    || (window.navigator.userAgent.indexOf('Trident/') > 0)
};
export const isFirefox = () => navigator.userAgent.toLowerCase().indexOf("firefox") > -1;

let __pricingProfiles = null;
let __pricingProfilesHit = false;
const pricingProfiles = () => {
  if (!__pricingProfilesHit) {
    __pricingProfilesHit = true;

    const storeState = store.getState();
    let presets = storeState.fabricatorState.pricingPreset;
    if (storeState.cartState?.markUpLogic?.useBase) {
      presets = updatePricingPresetsWithUseBaseLogic(presets, storeState.cartState.markUpLogic.useBase);
      console.log("Presets were updated with useBase logic:", presets);
    }

    __pricingProfiles = QuotePricing(presets);
  }

  console.log("__pricingProfiles", __pricingProfiles);

  return __pricingProfiles;
};

export const FEATURE_INSTALLATION = 1;
export const FEATURE_REGULAR = 2;
export const FEATURE_STONE = 3;

export const getFeatureType = dbFeature => {
  if (dbFeature && dbFeature.isInstallation)
    return FEATURE_INSTALLATION;
  if (dbFeature && (!dbFeature.stonePricingId || dbFeature.stonePricingId.length === 0 || dbFeature.stonePricingId[0] === -1))
    return FEATURE_REGULAR;
  return FEATURE_STONE;
};

/**
 *
 * @param cartItem {cartItemInterface} this is used to calculate first all same name countertops, than display it's total price / quantity, exclude current editing
 * @return {cartItemInterface}
 */
export const detectComplexLaborCartItem = (cartItem) => {
  return cartItem.cartFeature && (cartItem.partId === "installation")
    && cartItem.cartFeature.dbFeature.autoAddToCart && cartItem.cartFeature.dbFeature.complexLogic
}

const hardcodedFloformV5Features = ["Costco Shop Card", "Costco Citi Visa Cardholder", "Costco Executive Members"];

/**
 *
 * @param forQuote {any} get total prices only for specific quote (number or null)
 * @param calculateDiscount {boolean}
 * @param cartItemsToCount {array}
 * @param withNotInStock {boolean}
 * @param withoutLowesDiscount {boolean}
 * @return {object}
 */
export const getTotalPrice = (forQuote = null, calculateDiscount = true, cartItemsToCount = null, withNotInStock = false, withoutLowesDiscount = false) => {
  const state = store.getState();
  let cartItems = cartItemsToCount || state.cartState.cartItems;
  if (IS_LIXIL_UI && !cartItemsToCount) {
    cartItems = cartItems.filter(cartItem => {
      if ((IS_PRODUCT_JOURNEY && cartItem.addedBy !== CART_ITEM_ADDED_BY.user) || cartItem.isRemoved) {
        return false
      }
      if (withNotInStock) {
        return !getBundledFeatures(cartItem.cartFeature).length
      }
      return isInStock(cartItem.cartFeature) && !getBundledFeatures(cartItem.cartFeature).length
    });
  }
  const instList = state.instState.instList;
  const {fabricatorTaxes, settings} = state.fabricatorState;
  const {sureTax} = state.cartState;

  let materialPrice = 0;
  let materialTaxes = 0;
  let totalDeliveryCost = 0;
  let priceTaxes = Array.isArray(fabricatorTaxes) ? fabricatorTaxes.map(fabTax => {
    return {...fabTax, materialTax: 0, laborTax: 0}
  }) : [];
  let installationPrice = getInstallationsTotalCost(instList);

  if (Number.isInteger(forQuote)) {  // get total prices only for specific quote
    cartItems = cartItems.filter(cartItem => cartItem.currentQuote === forQuote)
  }

  let multipliedCostUsed = false;

  cartItems
    .sort((a, b) => (a.partId === "installation") - (b.partId === "installation"))
    .forEach(cartItem => {

      if ((getDifferentCurrencyCartItems(settings, [cartItem]).length && !cartItemsToCount)
        || cartItem.isRemoved
        || (multipliedCostUsed && detectComplexLaborCartItem(cartItem))
        || (cartItem.cartFeature && hardcodedFloformV5Features.some(name => cartItem.cartFeature.dbFeature.sharedFeatureName === name))
      ) {
        // if (cartItem.cartFeature.dbFeature.sharedFeatureName !== "Costco Shop Card") {
        return false
      }

    const dbFeature = cartItem.cartFeature.dbFeature;
    let featurePrice = 0;

    if (parseFloat(cartItem.displayFakePrice) === cartItem.displayFakePrice) {
      featurePrice = cartItem.displayFakePrice
    } else {
      const featureType = getFeatureType(dbFeature);
      switch (featureType) {
        case FEATURE_INSTALLATION:
          // installation dbFeature
          //installationPrice += calculateFeatureCost(cartItem.cartFeature, cartItem.quantity);
          // never gets here
          break;
        case FEATURE_REGULAR:
          // regular dbFeature, part of the total cost
          featurePrice = calculateFeatureCost(cartItem.cartFeature, cartItem.quantity, cartItems, cartItem.fromQtCategory, cartItem.currentQuote, cartItem);
          break;
        case FEATURE_STONE: {
          const stonePricing = state.serverState.stonePricing;
          const stoneSupplier = state.fabricatorState.stoneSupplier;
          // dbFeature stone related
          const stoneCost = calculateStoneCost(
            dbFeature,
            cartItem.quantity,
            stonePricing,
            stoneSupplier,
            cartItem.partId === SQFT_FEATURES.slabs && state.sqftSlabState.isSlabPricingEnabled, //cartItem.shouldUseSlabPricing, // calculate shouldUseSlabPricing globally and not per cItem
            settings,
            state.cartState,
          );
          const multipliedCost = multiplySlabCostForFeature(cartItem.cartFeature, cartItem.quantity, state, cartItem);
          if (multipliedCost && cartItem.partId !== "slabs") {
            featurePrice =  multipliedCost;
            multipliedCostUsed = true;
          } else {
            featurePrice = stoneCost || calculateFeatureCost(cartItem.cartFeature, cartItem.quantity, cartItems, cartItem.fromQtCategory, cartItem.currentQuote, cartItem);
          }
          break;
        }
        default:
          break;
      }
      const multiplier = state.quotesState.quotes[cartItem.currentQuote] && state.quotesState.quotes[cartItem.currentQuote].roomMultiplier
        ? state.quotesState.quotes[cartItem.currentQuote].roomMultiplier
        : 1;
      if (multiplier > 1) {
        featurePrice = featurePrice * multiplier;
      }
    }

    cartItem.cartItemPrice = featurePrice; // is used for complex logic

    const productPriceAfterDiscount = calculateDiscount
      ? getQuotePriceWithDiscounts({materialPrice:featurePrice}, [], true, cartItem.currentQuote, withoutLowesDiscount)
      : featurePrice
    materialPrice = materialPrice + productPriceAfterDiscount;
    if (fabricatorTaxes && !dbFeature.notTaxable && !settings.sureTax) {
      if (Array.isArray(fabricatorTaxes)) {
        priceTaxes = priceTaxes.map(tax => {
          tax.materialTax += productPriceAfterDiscount * tax.materialRate / 100;
          return tax
        })
      } else {
        materialTaxes += productPriceAfterDiscount * fabricatorTaxes.materialRate / 100;
      }
    }
    if (settings.useShipping) {
      totalDeliveryCost += getCartItemShippingCost(cartItem);
    }
  });

  if (isCafeCountetops) {
    totalDeliveryCost += getCafeCountertopsDeliveryCost(totalDeliveryCost, cartItems, state);
  }

  if ((typeof sureTax === "number") && sureTax > 0) {
    materialTaxes = sureTax;
  }

  if (priceTaxes[0] && priceTaxes[0].costcoPercent && materialPrice) {
    const productsPrice = materialPrice * priceTaxes[0].costcoPercent / 100; //here we calculate only 80% taxes (from product),
    // the other 20% is labor (not taxable)
    materialTaxes = productsPrice * priceTaxes[0].materialRate / 100; // now we can take percentage of products price (without labor)
    priceTaxes[0].materialTax = materialTaxes;
  }

  const result = {
    materialPrice: Math.round(materialPrice * 100) / 100,
    installationPrice: Math.round(installationPrice * 100) / 100,
    materialTaxes: Math.round(materialTaxes * 100) / 100,
    totalDeliveryCost: Math.round(totalDeliveryCost * 100) / 100,
    priceTaxes,
    installationTaxes: 0,
    multipliedCostUsed,
  };

  if (fabricatorTaxes) {
    result.installationTaxes = Array.isArray(fabricatorTaxes)
      ? fabricatorTaxes
        .filter(fabTax => fabTax.isEnabled)
        .reduce((acc, tax) => acc + (result.installationPrice * tax.laborRate / 100.0), 0)
      : result.installationPrice * fabricatorTaxes.laborRate / 100.0;
  }

  return result;
};

export function getQuotePriceWithDiscounts(
  totalPriceObject,
  ignoreDiscounts = [],
  splitStaticPrice = false,
  forQuoteIndex,
  withoutLowesDiscount = false
) {
  const state = store.getState();
  let totalPrice = totalPriceObject.materialPrice;
  if (state.fabricatorState.settings.priceWorksheetEnabled) {
    const discountSections = getFilteredSections(state.priceWorksheetState.discountSections);
    // const forTotal = !splitStaticPrice; // for subtotal we need to apply discounts per room price
    const hasMultipleWorkSheets = shouldUseMultipleWorkSheets(state.priceWorksheetState.workSheetsCount);
    discountSections.forEach(discountSection => {
      if (hasMultipleWorkSheets && !discountSectionExistsInCurrentWizardSelections(
        discountSection,
        state.wizardState.allWizardsValues,
        forQuoteIndex)
      ) {
        return
      }
      const allDiscounts = sortByOrder(getDiscountsForSection(discountSection, state.priceWorksheetState.customAddedDiscounts));
      allDiscounts.forEach(discount => {
        if (withoutLowesDiscount && (discount.discountType === DISCOUNT_MAIN_TYPES.lowesIME)) {
          return
        }
        if (shouldCalculateDiscount(discount, forQuoteIndex, hasMultipleWorkSheets, ignoreDiscounts)
          && (!ignoreDiscounts.length || ignoreDiscounts.every(ignoreDiscount => ignoreDiscount.id !== discount.id))) {
          const calculateFromCartItems = hasMultipleWorkSheets
            ? state.cartState.cartItems.filter(cartItem => cartItem.currentQuote === forQuoteIndex)
            : state.cartState.cartItems;
          const amount = getDiscountCurrentValue(discount, "amount", forQuoteIndex, hasMultipleWorkSheets);
          const realType = getDiscountCurrentValue(discount, "type", forQuoteIndex, hasMultipleWorkSheets);
          totalPrice = (realType === DISCOUNT_TYPES.price)
            ? totalPrice - (splitStaticPrice ? amount / calculateFromCartItems.length : amount)
            : totalPrice * (1 - amount/100) // total - percent
        }
      })
    })
  }
  return totalPrice;
}

export function getPriceWithTaxes(totalPriceObject) {
  const taxes = totalPriceObject.priceTaxes.length
    ? totalPriceObject.priceTaxes.reduce((acc, tax) => acc + tax.materialTax, 0)
    : totalPriceObject.materialTaxes;

  const totalPrice = totalPriceObject.materialPrice + taxes;
  return +toFixedPrice(totalPrice);
}

export function getQuotePriceWithTaxes(totalPriceObject) {
  const taxes = totalPriceObject.priceTaxes.length && !totalPriceObject.priceTaxes[0].costcoPercent
    ? totalPriceObject.priceTaxes.reduce((acc, tax) => acc + tax.materialTax, 0)
    : totalPriceObject.materialTaxes;

  const totalPrice = totalPriceObject.totalDeliveryCost + totalPriceObject.materialPrice + taxes + totalPriceObject.installationPrice + totalPriceObject.installationTaxes;
  return +toFixedPrice(totalPrice);
}

export function getDeliveryCost(deliveryList) {
  if (!deliveryList) {
    deliveryList = store.getState().cartState.deliveryList || [];
  }
  let deliveryCostArray = [];
  deliveryList.forEach(delivery => {
    // const activeDelivery = deliveryList.find((del, deliveryIndex) => deliveryIndex === delivery.activeDeliveryIndex);
    // if (activeDelivery && !deliveryCostArray.includes(activeDelivery.price)) {
    //   deliveryCostArray.push(activeDelivery.price)
    // }
    if (delivery.cartItems.length) {
      deliveryCostArray.push(delivery.price)
    }
  });
  return deliveryCostArray.reduce((total, cost) => total + cost, 0);
}

/**
 *
 * @param feature {object} (object which has dbFeature property)
 * @param quantity {int}
 * @param state {object}
 * @param cartItemToSkip {cartItemInterface} this is used to calculate first all same name countertops, than display it's total price / quantity, exclude current editing
 * @return {number}
 */
const multiplySlabCostForFeature = (feature, quantity, state, cartItemToSkip) => {
  const stonePricing = state.serverState.stonePricing;
  const stoneSupplier = state.fabricatorState.stoneSupplier;
  const allCartItems = state.cartState.cartItems;
  const isSlabPricingEnabled = state.sqftSlabState.isSlabPricingEnabled;

  let allSameFeaturesQuantity = quantity;
  const checkCartItems = allCartItems.filter(cItem => {
    return cItem.cartFeature && (cItem.cartFeature.dbFeature.sharedFeatureName === feature.dbFeature.sharedFeatureName)
  });
  checkCartItems.forEach(cItem => {
    if (cartItemToSkip && (cartItemToSkip.id === cItem.id)) { // current editing on feature page
      return
    }
    // Skip adding quantity if it's a slab and slab pricing is disabled
    if (!(cItem.partId === SQFT_FEATURES.slabs && !isSlabPricingEnabled)) {
      allSameFeaturesQuantity += cItem.quantity;
    }
  });
  if ((checkCartItems.length > 1 || (checkCartItems[0] && checkCartItems[0].partId !== feature.partId))
    && allSameFeaturesQuantity && (allSameFeaturesQuantity !== quantity)) {
    let allStoneCost = calculateStoneCost(
      feature.dbFeature,
      allSameFeaturesQuantity,
      stonePricing,
      stoneSupplier,
      false,
      state.fabricatorState.settings,
      state.cartState,
    );
    const laborExist = allCartItems.find(cItem => detectComplexLaborCartItem(cItem)) // here we check existing auto add to cart feature (which is depending on countertop quantity)
    if (laborExist) {
      allStoneCost += getFeatureCost(laborExist.cartFeature, laborExist.quantity, laborExist.fromQtCategory);
    }
    // console.log("quantity", quantity);
    // console.log("allSameFeaturesQuantity", allSameFeaturesQuantity);
    // console.log("allStoneCost", allStoneCost);
    return Math.round((quantity * (allStoneCost / allSameFeaturesQuantity)) * 100) / 100
  }
  return 0
}

/**
 *
 * @param feature {object} (object which has dbFeature property)
 * @param quantity {int}
 * @param fromQtCategory {string} (cart feature should be calculated from the category it was added)
 * @param withTotalSlabCost {boolean} this is used to calculate first all same name countertops, than display it's total price / quantity
 * @param cartItemToSkip {cartItemInterface} this is used to calculate first all same name countertops, than display it's total price / quantity, exclude current editing
 * @param useSlabSqftPricing {boolean} this is used to calculate slab pricing assigned from algorithms, slabSqftValue from backed
 * @param forQuoteIndex {number} for complex logic
 * @return {number}
 */
export const getFeatureCost = (feature,
                               quantity,
                               fromQtCategory,
                               withTotalSlabCost = false,
                               cartItemToSkip = null,
                               useSlabSqftPricing = false,
                               forQuoteIndex = null,
) => {
  const state = store.getState();
  let featurePrice = 0;
  switch (getFeatureType(feature.dbFeature)) {
    case FEATURE_INSTALLATION: // installation dbFeature
    case FEATURE_REGULAR:
      // regular feature, part of the total cost
      featurePrice = calculateFeatureCost(feature, quantity, null, fromQtCategory, forQuoteIndex, cartItemToSkip);
      break;
    case FEATURE_STONE: {
      // is a stone, calculate using a different algorithm.
      const stonePricing = state.serverState.stonePricing;
      const stoneSupplier = state.fabricatorState.stoneSupplier;
      // feature stone related
      // console.log("stonePricing", stonePricing);
      // console.log("stoneSupplier", stoneSupplier);
      // console.log("feature.dbFeature.stonePricingId", feature.dbFeature.stonePricingId);
      const stoneCost = calculateStoneCost(
        feature.dbFeature,
        quantity,
        stonePricing,
        stoneSupplier,
        useSlabSqftPricing,
        state.fabricatorState.settings,
        state.cartState,
      );
      if (stoneCost && withTotalSlabCost && cartItemToSkip.partId !== SQFT_FEATURES.slabs) {
        // console.log("stoneCost", stoneCost);
        const multipliedCost = multiplySlabCostForFeature(feature, quantity, state, cartItemToSkip);
        if (multipliedCost) {
          featurePrice = multipliedCost;
          break;
        }
      }
      featurePrice = stoneCost || calculateFeatureCost(feature, quantity, null, fromQtCategory, forQuoteIndex, cartItemToSkip);
      break;
    }
  }
  const multiplier = cartItemToSkip
  && state.quotesState.quotes[cartItemToSkip.currentQuote]
  && state.quotesState.quotes[cartItemToSkip.currentQuote].roomMultiplier
    ? state.quotesState.quotes[cartItemToSkip.currentQuote].roomMultiplier
    : 1;
  if (multiplier > 1) {
    featurePrice = featurePrice * multiplier;
  }
  // half price for cabinet drawers
  if (cartItemToSkip && cartItemToSkip.quantityGroup === QUANTITY_GROUP.drawers
    && CABINET_PART_IDS_WITH_HALF_PRICE.includes(cartItemToSkip.partId)
    && sqftConfig.shouldUseCabinetDoorsAndDrawersQuantity
  ) {
    featurePrice = featurePrice / 2
  }

  return featurePrice;
};

export const toFixedPrice = (price, withCommas = false) => {
  try {
    if (Math.round(price) !== price || IS_LIXIL_UI) {
      price = price.toFixed(2);
    }
  } catch(ex) {
    console.log("Helpers toFixedPrice failed for ", price, ex);
  }
  return withCommas ? numberWithCommas(price) : price
};

/**
 *
 * @param feature {object} (object which has dbFeature property)
 * @param quantity {int}
 * @param fromQtCategory {string} (cart feature should be calculated from the category it was added)
 * @param withTotalSlabCost {boolean} this is used to calculate first all same name countertops, than display it's total price / quantity
 * @param cartItemToSkip {featureInterface} this is used to calculate first all same name countertops, than display it's total price / quantity, exclude current editing
 * @param useSlabSqftPricing {boolean} this is used to calculate slab pricing assigned from algorithms, slabSqftValue from backed
 * @param forQuoteIndex {number} for the complex logic
 * @return {string}{number}
 */
export const toFixedFeatureCost = (feature,
                                   quantity,
                                   fromQtCategory = "",
                                   withTotalSlabCost = false,
                                   cartItemToSkip = null,
                                   useSlabSqftPricing = false,
                                   forQuoteIndex = null,
) => {
  let price = getFeatureCost(feature, quantity, fromQtCategory, withTotalSlabCost, cartItemToSkip, useSlabSqftPricing, forQuoteIndex);
  return toFixedPrice(price);
};

/**
 *
 * @return {number}
 */
export const getSingleSlabArea = () => {
  const storeState = store.getState();
  const slabImageHeight = storeState.sqftSlabState.slabImageHeight;
  const slabImageWidth = storeState.sqftSlabState.slabImageWidth;
  const slabArea = slabImageHeight * slabImageWidth;

  return sqftConfig.measureUnit === "Imperial"
    ? Math.ceil10(sqInchesToSqFoot(slabArea), -2)
    : mm2ToM2(slabArea);
};

const getCartItemObjectForComplexLogic = (ci) => {
  return {
    id: ci.cartFeature.dbFeature.id,
    quantity: ci.quantity,
    name: ci.cartFeature.dbFeature.customDisplayName || ci.cartFeature.dbFeature.displayName,
    sharedFeatureName: ci.cartFeature.dbFeature.sharedFeatureName,
    groupName: ci.cartFeature.dbFeature.groupName,
    wizardGroupId: ci.fromWizardGroupId,
    currentQuote: ci.currentQuote,
    partId: ci.partId,
    cartItemId: ci.id, // hash
    complexLogic: ci.cartFeature.dbFeature.complexLogic,
    cartItemPrice: ci.cartItemPrice,
  }
}

/**
 *
 * @param feature {featureInterface} (object which has dbFeature property)
 * @param quantity {int}
 * @param cartItems {array}
 * @param fromQtCategory {string} (cart feature should be calculated from the category it was added)
 * @param quoteIndex {number}
 * @param forCartItem {cartItemInterface}
 * @return {number}
 */
function calculateFeatureCost(feature, quantity, cartItems, fromQtCategory, quoteIndex, forCartItem = null) {
  // is a stone, calculate using a different algorithm.
  const storeState = store.getState();
  const stonePricing = storeState.serverState.stonePricing;
  const stoneSupplier = storeState.fabricatorState.stoneSupplier;
  const activeQuoteIndex = Number.isInteger(quoteIndex) ? quoteIndex : storeState.quotesState.activeQuoteIndex;
  const dbFeature = feature.dbFeature;

  let featureCost = checkIfInCatProperty(feature, "inCatPrice", getFeaturePriceProperty(feature), fromQtCategory);

  if (storeState.cartState.markUpLogic) { // global
    featureCost = updatePriceWithMarkUp(featureCost, storeState.cartState.markUpLogic, storeState.fabricatorState.settings);
  }
  if (dbFeature.markUpString) { // features mark up should update after global
    featureCost = updatePriceWithFeatureMarkUp(featureCost, dbFeature.markUpString, storeState.fabricatorState.settings);
  }

  let featureTotalPrice = 0;

  let material = 0;
  let materialPrice = 0;
  let backsplashMaterial = 0;

  let quoteMaterial = 0;
  let quoteBacksplashMaterial = 0;

  let materials = [];
  for(let index in storeState.cartState.cartItems) {
    let cartItem = storeState.cartState.cartItems[index];
    if(cartItem.cartFeature && cartItem.cartFeature.isStoneFeature) {
      switch (cartItem.partId) {
        case "vanity_countertop":
        case "center_island_countertop":
        case "countertop":
        case "front_wall": {
          if (cartItem.partId === "front_wall") { // added front_wall to the Fireplace material
            const visType = cartItem.fromVisualizerType || document.kvConfig.visualizerType;
            if (visType !== "Fireplace") {
              break;
            }
          }
          material += cartItem.quantity;
          // dbFeature stone related
          const currentPrice = calculateStoneCost(
            cartItem.cartFeature.dbFeature,
            cartItem.quantity,
            stonePricing,
            stoneSupplier,
            cartItem.partId === SQFT_FEATURES.slabs && storeState.sqftSlabState.isSlabPricingEnabled, //cartItem.shouldUseSlabPricing,// calculate shouldUseSlabPricing globally and not per cItem
            storeState.fabricatorState.settings,
            storeState.cartState,
          );
          materialPrice += currentPrice;
          if (cartItem.currentQuote === activeQuoteIndex) {
            quoteMaterial += cartItem.quantity;
          }
          materials.push(cartItem.cartFeature.dbFeature);
          break;
        }
        case "vanity_backsplash":
        case "backsplash": {
          backsplashMaterial += cartItem.quantity;
          if (cartItem.currentQuote === activeQuoteIndex) {
            quoteBacksplashMaterial += cartItem.quantity;
          }
          break;
        }
        default:
          break;
      }
    }
  }

  const measureUnit = storeState.sqftState ? storeState.sqftState.measureUnit : null;
  if (validateFeaturePrice(dbFeature, quantity, measureUnit)) {
    let complexLogic = checkIfInCatProperty(feature, "complexLogic", dbFeature.complexLogic, fromQtCategory);
    if (dbFeature.comparisonType === 'gte+' && dbFeature.comparisonFor !== 'complex') {
      const baseQuantity = feature.baseQuantity - 1;
      let fQuantity = quantity;
      if (dbFeature.comparisonFor === 'material') {
        fQuantity = 0; // no material quantity
      }
      const plus = dbFeature.maxQuantity;
      let cost = baseQuantity * featureCost;
      for (let i = baseQuantity + 1; i <= fQuantity; i++) {
        cost += plus;
      }

      featureTotalPrice = cost;
    } else if (hardcodedFloformV5Features.some(name => dbFeature.sharedFeatureName === name)) {
      if (dbFeature.sharedFeatureName === "Costco Shop Card") {
        featureTotalPrice = getCostcoShopCartCost(storeState.cartState.cartItems);
      } else {
        const totalPrice = getTotalPrice();
        featureTotalPrice = totalPrice.materialPrice * 0.02;
      }
    } else if (dbFeature.comparisonFor === 'complex' && complexLogic) {
      try {

        const $m = material; // amount of square foot of material the feature is using, probably have to be calculated based on the meta data size of the feature
        const $b = backsplashMaterial; // we added a new backsplash property, if we need to calculate both, we should have ($m + $b) in the complex logic
        const getSqft = (stonePricingId) => {
          const stoneSupplierStone = stonePricing[stonePricingId]; // stone supplier stone
          if (!stoneSupplierStone) {
            return -1
          }
          const pricingProfileId = stoneSupplierStone.pricingPreset_id;
          const quotePricing = __quotePricing || (__quotePricing = pricingProfiles());
          const profile = quotePricing.pricingProfiles.find((pp) => (pp.Id || pp.id) === pricingProfileId);
          if(profile) {
            var ppdList = storeState.fabricatorState.settings.useFabricatorCostPrices
              ? profile.pricingProfileCostData
              : storeState.fabricatorState.settings.showSalePrices
                ? profile.pricingProfileDiscountData
                : profile.pricingProfileData;
            if (Array.isArray(ppdList) && ppdList.length) {
              for(var n = ppdList.length - 1; n >= 0; n--) {
                let ppd = ppdList[n];
                switch(ppd.type)
                {
                  case "pricing-presets/set-slab":
                    if(ppd.slabSqftValue > 0) {
                      return ppd.slabSqftValue;
                    }
                    else {
                      return parseFloat(ppd.value) / parseFloat(ppd.end);
                    }
                  default:
                    return -1;
                }
              }
            }
          }
        };
        var materialSqft = -1;
        for (const m in materials) {
          if (Array.isArray(materials[m].stonePricingId)
            && materials[m].stonePricingId.length
            && materials[m].stonePricingId[0]) {
            const msqft = getSqft(materials[m].stonePricingId[0]);
            if (msqft > materialSqft) {
              materialSqft = msqft;
            }
          }
        }

        const $mc = materialSqft > -1 ? materialSqft : materialPrice / material; // material cost broken down to square foot
        const $p = 1; // the per-quantity value of the selected material of the feature

        const $f = quantity; // the feature quantity of the selected feature
        const $c = featureCost; // the feature cost of the selected features
        const $fa = storeState.cartState.cartItems
          ? storeState.cartState.cartItems.map(ci => getCartItemObjectForComplexLogic(ci))
          : []; // an array of key value pairs with the keys being feature id and value being quantity

        if (storeState.wizardState.wizardActiveItem) { // we need to check wizard current selected values to display prices
          Object.keys(storeState.wizardState.wizardSelectedValues).forEach(stepIndex => {
            const selectedValue = storeState.wizardState.wizardSelectedValues[stepIndex];
            if (selectedValue.selectedFeature && selectedValue.quantity) {
              $fa.push({
                id: selectedValue.selectedFeature.dbFeature.id,
                quantity: selectedValue.quantity,
                name: selectedValue.selectedFeature.dbFeature.customDisplayName || selectedValue.selectedFeature.dbFeature.displayName,
                groupName: selectedValue.selectedFeature.dbFeature.groupName
              })
            }
          })
        }
        const $room = {
          $i: activeQuoteIndex,
          $m: quoteMaterial,
          $b: quoteBacksplashMaterial,
        }
        const $other = { // to prevent creating new parameters, all new properties should go here
          $useCostPrices: storeState.fabricatorState.settings.useFabricatorCostPrices,
          $useDiscountPrices: storeState.fabricatorState.settings.showSalePrices,
          $sharedFeatureName: dbFeature.sharedFeatureName,
          $groupName: dbFeature.groupName,
          $forCartItem: forCartItem ? getCartItemObjectForComplexLogic(forCartItem) : null,
        }
        // const $fs = layout.dataObject.features; // its an array of all the fabricator's features
        const $fs = []; // its an array of all the fabricator's features
        const logic = new Function('$m', '$mc', '$f', '$c', '$fa', '$fs', '$p', '$b', '$room', '$other', complexLogic);
        featureTotalPrice = logic($m, $mc, $f, $c, $fa, $fs, $p, $b, $room, $other);
        // console.log(888, 'Complex', feature.complexLogic, featureCost, quantity);
      } catch (e) {
        console.log('Feature complex logic failed.', e);
      }
    } else if (dbFeature.comparisonType === "min" && dbFeature.comparisonFor !== "complex") {
      if (quantity < dbFeature.baseQuantity) {
        featureTotalPrice = featureCost * dbFeature.baseQuantity;
      } else {
        featureTotalPrice = quantity * featureCost;
      }
    } else {
      featureTotalPrice = featureCost * quantity;
    }
  }

  if (isNaN(featureTotalPrice)) {
    return 0
  }
  return featureTotalPrice;
}

let __stoneSupplierStones = null;
let __quotePricing = null;

export function calculateStoneCost(feature, quantity, stonePricing, stoneSupplier, useSlabSqftPricing, fabricatorSettings, cartState) {
  if (!feature || (feature.stonePricingId && feature.stonePricingId.length === 1) && feature.stonePricingId[0] === -1) {
    // stone was not found
    if (feature) {
      const price = getFeaturePriceProperty({dbFeature: feature});
      if (price > 0) {
        return price
      }
    }
    return 0;
  }

  // only one fabricator here

  let minPrice = -1;
  const quotePricing = __quotePricing || (__quotePricing = pricingProfiles());
  const stoneSupplierStones = __stoneSupplierStones
    || (feature.stonePricingId && feature.stonePricingId.length > 0 ? __stoneSupplierStones = feature.stonePricingId.map(_ => stonePricing[_]) : null);

  if (feature.stonePricingId && feature.stonePricingId.length > 0 && feature.stonePricingId[0]) {
    feature.stonePricingId.forEach(id => {
      let materialPrice = -1;
      const stoneSupplierStone = stonePricing[id]; // stone supplier stone
      if (quotePricing && quotePricing.hasPricingProfileAssigned(stoneSupplierStone, fabricatorSettings)) {
        const singleSlabArea = getSingleSlabArea();
        const fabPrice = quotePricing.calculatePrice(
          stoneSupplierStone.pricingPreset_id,
          quantity,
          null,
          useSlabSqftPricing,
          singleSlabArea,
          feature,
          fabricatorSettings
        );
        if (materialPrice === -1 || fabPrice < materialPrice) {
          materialPrice = fabPrice;
        }
        if (minPrice === -1 || minPrice > materialPrice) {
          minPrice = materialPrice;
        }
      } else if (stoneSupplierStone) {
        let price = stoneSupplierStone.price;
        if (stoneSupplierStone.pricePlus > 0) {
          price = stoneSupplierStone.pricePlus;
        }
        let material = quantity;
        if (stoneSupplierStone.perQuantity > 1) {
          material = Math.ceil(material / stoneSupplierStone.perQuantity);
        }
        let materialPrice = price * parseFloat(material);

        let baseQuantity;
        if (stoneSupplierStone.comparisonType === "gte+") {
          baseQuantity = parseInt(stoneSupplierStone.baseQuantity) - 1;
          if (material > baseQuantity) {
            let perUnit = parseFloat(stoneSupplierStone.maxQuantity);
            const margin = stoneSupplier.margin;
            perUnit = calcPriceWithMargin(perUnit, margin);
            materialPrice = baseQuantity * price;
            forEach(stoneSupplierStones, function (stoneSupplierStoneInner) {
              if (stoneSupplierStoneInner.comparisonType === "between" &&
                material >= stoneSupplierStoneInner.baseQuantity) {
                materialPrice = stoneSupplierStoneInner.price;
                for (let n = stoneSupplierStoneInner.maxQuantity + 1; n <= baseQuantity; n++) {
                  materialPrice += price;
                }
              }
            });
            for (let i = baseQuantity + 1; i <= material; i++) {
              materialPrice += perUnit;
            }
          }
        } else if (stoneSupplierStone.comparisonType === "min") {
          if (parseFloat(material) < stoneSupplierStone.baseQuantity) {
            materialPrice = price * parseFloat(stoneSupplierStone.baseQuantity);
          }
        } else if (stoneSupplierStone.comparisonType === "lte") {
          baseQuantity = parseInt(stoneSupplierStone.baseQuantity);
          if (material <= baseQuantity) {
            let bFoundOther = false;
            forEach(stoneSupplierStones, function (stoneSupplierStoneInner) {
              if (stoneSupplierStoneInner.comparisonType === "lte" &&
                material <= stoneSupplierStoneInner.baseQuantity
                && stoneSupplierStoneInner.baseQuantity < baseQuantity) {
                bFoundOther = true;
              }
            });
            if (bFoundOther) {
              return;
            }
          }
        } else if (stoneSupplierStone.comparisonType === "between") {
          materialPrice = stoneSupplierStone.price;
        }

        if (validStoneSupplierStonePrice(stoneSupplierStone, material)) {
          if (minPrice === -1 || minPrice > materialPrice) {
            minPrice = materialPrice;
          }
        }
      }
    });
  }

  if (cartState.markUpLogic) { // global
    minPrice = updatePriceWithMarkUp(minPrice, cartState.markUpLogic, fabricatorSettings);
  }
  if (feature.markUpString) { // features mark up should update after global
    minPrice = updatePriceWithFeatureMarkUp(minPrice, feature.markUpString, fabricatorSettings);
  }

  return Math.trunc(minPrice * 100) / 100;
}

function calcPriceWithMargin(price, margin) {
  const total = parseFloat(price);
  return (total + (margin * total));
}

// function calcPriceWithTax(price, tax) {
//   const total = parseFloat(price);
//   return (total + (tax / 100.0 * total));
// }

function validStoneSupplierStonePrice(stoneSupplierStone, quantity) {
  let ret = false;
  let material = quantity;
  if (stoneSupplierStone.perQuantity > 1) {
    material = Math.ceil(material / stoneSupplierStone.perQuantity);
  }
  switch (stoneSupplierStone.comparisonType) {
    case "lte":
      if (material <= stoneSupplierStone.baseQuantity) {
        ret = true;
      }
      break;
    case "between":
      if (material >= stoneSupplierStone.baseQuantity
        && material <= stoneSupplierStone.maxQuantity) {
        ret = true;
      }
      break;
    case "gte":
    case "gte+":
      if (material >= stoneSupplierStone.baseQuantity) {
        ret = true;
      }
      break;
    default:
      ret = true;
  }
  return ret;
}

function validateFeaturePrice(feature, quantity, measureUnit) {
  let ret = false;
  switch (feature.comparisonType) {
    case "lte":
      if (quantity <= feature.baseQuantity) {
        ret = true;
      }
      break;
    case "between":
      if (quantity >= feature.baseQuantity && quantity <= feature.maxQuantity) {
        ret = true;
      }
      break;
    case "gte":
    case "gte+":
      if ((quantity >= feature.baseQuantity) || ((measureUnit === "Metric") && (quantity > 0) && (feature.baseQuantity === 1))) {
        ret = true;
      }
      break;
    default:
      ret = true;
  }

  return ret;
}

export function parseQuery(queryString = null) {
  queryString = queryString || window.location.search;
  const query = {};
  const pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
  for (let i = 0; i < pairs.length; i++) {
    let pair = pairs[i].split('=');
    query[decodeURIComponent(pair[0]).toLowerCase()] = decodeURIComponent(pair[1] || '');
  }
  return query;
}
export function metaDataToCamelCase(metaData) {
  if (!metaData) {
    metaData = {}; // it could be null, so default parameter is not working
  }
  Object.keys(metaData).forEach(key => { // make all metadata keys CamelCased (dashboard saving issue)
    if (key[0] !== key[0].toUpperCase()) {
      const value = metaData[key];
      const camelCased = key.charAt(0).toUpperCase() + key.slice(1);
      metaData[camelCased] = value;
      delete metaData[key]; // we don't need lowerCased key anymore
    }
  });
  return metaData;
}

export const capitalizeFirstLetters = (str) => {
  if (!str) {
    return ""
  }
  return str.split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(" ")
}

// export const getObjectWithLowerCasedKeys = (obj) => {
//   let
//     key,
//     keys = Object.keys(obj),
//     n = keys.length,
//     newObj={};
//   while (n--) {
//     key = keys[n];
//     newObj[key.toLowerCase()] = obj[key];
//   }
//   return newObj
// };

export const getCurrencySign = (currencyName, fabricatorSettings) => {
  switch (currencyName) {
    case "USD":
    default:
      return fabricatorSettings.useDifferentCurrencies ? "USD" : "$";
    case "SPN":
    case "EUR":
      return "€";
    case "GBP":
      return "£";
    case "PAB":
      return "B/.";
    case "PLN":
      return "zł";
    case "ARS":
      return "$";
  }
};

export const getCurrencyPosition = (currencyName) => {
  switch (currencyName) {
    case "USD":
    case "SPN":
    case "EUR":
    case "GBP":
    case "PAB":
    case "ARS":
    default:
      return "left";
    case "PLN":
      return "right";
  }
};

/**
 *
 * @param fabricatorSettings {object} fabricatorSettings
 * @param price {string|number}
 * @param feature {featureInterface}
 * @param withSpace {boolean}
 * @param alwaysRound {boolean} // returns $10 -> $10.00
 * @return {string}
 */
export const getPriceWithCurrency = (fabricatorSettings, price,  feature = null, withSpace = false, alwaysRound = false) => {
  if (fabricatorSettings.currencyPosition === "right") {
    return price + fabricatorSettings.currencySign
  }
  let currencySign = fabricatorSettings.currencySign;
  if (fabricatorSettings.useDifferentCurrencies && feature && feature.getFeatureCurrency) {
    const separateCurrency = feature.getFeatureCurrency();
    if (separateCurrency) {
      currencySign = getCurrencySign(separateCurrency, fabricatorSettings);
    }
  }
  if (fabricatorSettings.useDifferentCurrencies) {
    if (currencySign === "USD") {
      withSpace = true;
    }
    price = numberWithCommas(price);
  }
  if (currencySign === "$") {
    const amount = typeof price === "string" ? +(price.replace(",", "")) : price;
    const isExact = !alwaysRound && (Number.isInteger(amount) || amount % 1 === 0);
    // Create the formatter
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: isExact ? 0 : 2,
      maximumFractionDigits: isExact ? 0 : 2,
    });
    return formatter.format(amount);
  }
  return withSpace ? currencySign + " " + price : currencySign + price
};

export const getFeatureIsLocked = (feature, ignoreLocked = false) => {
  if (!feature) {
    return false
  }
  const leadCaptureProperty = isVisualizerRoute() || IS_LIXIL_UI ? "leadCapture"  : "leadCaptureOnQuote";
  const {fabricatorState, userState, filterState} = store.getState();

  const fabricatorSettings = fabricatorState.settings;
  const {isBackend, jobId, canSaveQuote, visualizerManagement} = document.kvConfig;
  const isPhoneNumberValidated = userState.isPhoneNumberValidated;

  if (fabricatorSettings.leadCaptureShoppingCart) {
    if (IS_LIXIL_UI && (window.location.hash.includes(ROUTES.cart) || window.location.hash.includes(ROUTES.list))) {
      return !isPhoneNumberValidated;
    } else {
      if (window.location.hash.includes("materials")) {
        return false
      } else if (window.location.hash.includes("shoppingcart")) {
        return !isPhoneNumberValidated;
      }
    }
  }

  let featureIsLocked = !(
    ignoreLocked
    || !fabricatorSettings[leadCaptureProperty]
    || (fabricatorSettings[leadCaptureProperty] && visualizerManagement)
    || (fabricatorSettings[leadCaptureProperty] && isPhoneNumberValidated)
    || (fabricatorSettings[leadCaptureProperty] && (isBackend && jobId && canSaveQuote)));
  if (featureIsLocked) {
    featureIsLocked = !((feature.dbFeature && feature.dbFeature.unlocked) || isPhoneNumberValidated);
    if (!featureIsLocked && !IS_LIXIL_UI) { // search for locked filters // temporary removed from bvLook
      const filterValues = feature.dbFeature && feature.dbFeature.filterValueIDs;
      if (filterValues) {
        featureIsLocked = Object.keys(filterValues).some((filterKey) => {
          const filterGroup = filterState.filterGroups.find(group => group.id === +filterKey);
          const filterValue = filterGroup && filterGroup.values && filterGroup.values.find(value => value.id === filterValues[filterKey][0]);
          return filterValue && filterValue.lockedInWizard
        });
      }
    }
  }
  return featureIsLocked
};

export const sortByOrder = (array) => {
  return array.sort((a, b) => a.order !== b.order ? a.order < b.order ? -1 : 1 : 0); // sort by order property
};

export const objectWithoutProperties = (obj, keys) => {
  let target = {};
  for (let i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}

/**
 * returns array of Ids, etc. [2313743, 2313335, 2320458]
 * @param bvState {object}
 * @param checkDifferentVisualizers {boolean}
 * @return {[number]}
 */
export const getArrayOfIdsFromBvState = (bvState, checkDifferentVisualizers = false) => {
  let arrayOfIds = [];
  if (bvState) {
    Object.keys(bvState).forEach((key) => {
      const bvStateValue = bvState[key];
      if (Number.isInteger(bvStateValue) && bvStateValue > 50) { // check for layout_type
        if (key === "presetPrice") { // it is a number and it is more than 12
          return
        }
        arrayOfIds.push(bvStateValue)
      } else if (Array.isArray(bvStateValue)) {
        bvStateValue.forEach((bvStateValueArrayItem) => {
          if (Number.isInteger(bvStateValueArrayItem)) {
            arrayOfIds.push(bvStateValueArrayItem)
          }
        })
      } else if (typeof bvStateValue === 'object' && bvStateValue !== null) {
        ["cartItems", "displayLogicCartItems"].forEach((property) => {
          if (bvStateValue[property] && bvStateValue[property].length) {
            bvStateValue[property].forEach((cartItem) => {
              if (checkDifferentVisualizers && (cartItem.fromVisualizerType !== bvState.visualizerType)) {
                return // load only current visualizer features
              }
              if (cartItem.cartFeature && cartItem.cartFeature.dbFeatureId) {
                arrayOfIds.push(cartItem.cartFeature.dbFeatureId)
              } else if (cartItem.cartFeature && cartItem.fabFeatId) { // support for old logic
                arrayOfIds.push(cartItem.fabFeatId)
              }
            });
          }
        });
      }
    });
  }
  return uniq(arrayOfIds)
}

export const getShareUrl = (jobId) => {
  const url = new URL(window.location.href);
  console.log("url", url);
  let searchParams = new URLSearchParams(decodeURIComponent(url.search || "").replace(/amp;/gi, ""));
  ["show", "jobId", "mode", "saveQuote", ...LIXIL_USER_QUERY_PARAMS].forEach(param => {
    searchParams.delete(param);
  });
  searchParams.set("design", jobId);
  // const shareUrl = url.href
  //   .replace(/&show=?\w*?&/, "&")
  //   .replace(/&jobId=\d*/gi, "")
  //   .replace(/&mode=\w*/gi, "")
  //   .replace(/&saveQuote=\w*/gi, "")
  //   .split("#/")[0]

  let baseHref = url.origin + url.pathname;
  if (baseHref[baseHref.length - 1] === "/") {
    baseHref.slice(0, -1);
  }

  // const shareUrl = baseHref + "?" + searchParams.toString() + url.hash;
  const shareUrl = baseHref + "?" + searchParams.toString();
  // console.log("shareUrl", shareUrl);
  return shareUrl
};

export const getDefaultRoomName = (messages, quoteRoomType = "") => {
  switch (quoteRoomType || document.kvConfig.visualizerType) {
    case "Bathroom":
    case "BV":
    case "bvScene":
    case "bvLook":
      return messages["rooms.Bathroom"]
    case "Kitchen":
    case "KV":
    case "kvMaster":
    case "kvScene":
      return messages["rooms.Kitchen"]
    default:
      return quoteRoomType || document.kvConfig.visualizerType || ""
  }
}

/**
 * @param feature {featureInterface}
 * @param messages {object}
 * @param locale {string}
 * @param fabricatorData {object}
 * @param filterGroups {array}
 * @param useCollectionName {boolean}
 * @return {string}
 */
export const getStringFeatureName = (feature,
                                     messages,
                                     locale,
                                     fabricatorData,
                                     filterGroups,
                                     useCollectionName = false) => {
  if (!feature) {
    return ""
  }

  if ((fabricatorData.isLowes || fabricatorData.isCaesarStone) && messages) {
    if (locale === "fr-FR" && messages["transDoc.customDisplayName_FR." + feature.dbFeature.sharedFeatureName]) {
      return messages["transDoc.customDisplayName_FR." + feature.dbFeature.sharedFeatureName]
    } else if (locale === "pl-PL" && messages["transDoc.customTranslateName_PL." + feature.dbFeature.sharedFeatureName]) {
      return messages["transDoc.customTranslateName_PL." + feature.dbFeature.sharedFeatureName]
    }
  }

  if ((feature.dbFeature.sharedFeatureName === "additionalCartItem.minimumCharge")) {
    if (fabricatorData.isCaesarStone) {
      return `${messages[feature.dbFeature.sharedFeatureName]} (${feature.fromFeatureName})`
    }
    return messages[feature.dbFeature.sharedFeatureName]
  }

  if (!feature.getFeatureName) {
    return feature._customDisplayName || feature.customDisplayName || ""
  }

  return (useCollectionName && !fabricatorData.isEncore)
    ? feature.getCollectionName(filterGroups) || feature.getFeatureName()
    : feature.getFeatureName()
}

const upperCaseAlp = ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"];

/**
 * @param quoteIndex {number|string}
 * @param cartItems {array}
 * @param quotes {array}
 * @param messages {object}
 * @param locale {string}
 * @param fabricatorData {object}
 * @return {string}
 */
export const getRoomName = (quoteIndex, cartItems = [], quotes = [], messages, locale, fabricatorData) => {

  quoteIndex = +quoteIndex;

  const getCurentQuoteRoomItem = (quoteIndexToFind) => {
    return cartItems.find(cItem => (cItem.currentQuote === quoteIndexToFind) && (cItem.partId === "room"))
  };

  const quoteRoomNameToCompare = (currentQuoteIndex) => {
    const roomCartItem = getCurentQuoteRoomItem(currentQuoteIndex);
    if (roomCartItem && roomCartItem.cartFeature && roomCartItem.cartFeature.getLowerCasedCustomDisplayName) {
      return roomCartItem.cartFeature.getLowerCasedCustomDisplayName()
    }
    const quoteRoomType = quotes[currentQuoteIndex] && quotes[currentQuoteIndex].room ? quotes[currentQuoteIndex].room : "";
    return (getDefaultRoomName(messages, quoteRoomType) || "").toLowerCase();
  };


  const currentRoomName = quoteRoomNameToCompare(quoteIndex);
  const quoteRoomType = quotes[quoteIndex] && quotes[quoteIndex].room ? quotes[quoteIndex].room : "";
  const roomItem = getCurentQuoteRoomItem(quoteIndex);
  const baseRoomName = roomItem && roomItem.cartFeature
    ? getStringFeatureName(roomItem.cartFeature, messages, locale, fabricatorData)
    : getDefaultRoomName(messages, quoteRoomType);

  if (quotes.some((quote, currentQuoteIndex) => {
    return (quoteIndex !== currentQuoteIndex) && (quoteRoomNameToCompare(currentQuoteIndex) === currentRoomName)
  })) {
    let letterIndex = 0;
    for (let i = 0; i <= quotes.length; i++) {
      if ((i < quoteIndex) && (quoteRoomNameToCompare(i) === currentRoomName)) {
        letterIndex++
      }
    }
    return baseRoomName + upperCaseAlp[letterIndex] || ""
  }
  return baseRoomName || ""
};

/**
 * @param quoteIndex {number|string}
 * @param cartItems {array}
 * @param quotes {array}
 * @param messages {object}
 * @param locale {string}
 * @param fabricatorData {object}
 * @return {string}
 */
export const getBaseRoomName = (quoteIndex, cartItems = [], quotes = [], messages, locale, fabricatorData) => {

  quoteIndex = +quoteIndex;

  const getCurentQuoteRoomItem = (quoteIndexToFind) => {
    return cartItems.find(cItem => (cItem.currentQuote === quoteIndexToFind) && (cItem.partId === "room"))
  };

  const quoteRoomType = quotes[quoteIndex] && quotes[quoteIndex].room ? quotes[quoteIndex].room : "";
  const roomItem = getCurentQuoteRoomItem(quoteIndex);
  const baseRoomName = roomItem && roomItem.cartFeature
    ? getStringFeatureName(roomItem.cartFeature, messages, locale, fabricatorData)
    : getDefaultRoomName(messages, quoteRoomType);

  return baseRoomName || ""
};

export const getEventPosition = (e) => {
  const eventX = e.clientX ? e.clientX : (e.touches[0] ? e.touches[0].clientX : e.changedTouches[0].clientX);
  const eventY = e.clientY ? e.clientY : (e.touches[0] ? e.touches[0].clientY : e.changedTouches[0].clientY);
  return {
    x: parseFloat(eventX).toFixed(2),
    y: parseFloat(eventY).toFixed(2)
  }
};

export const getUrlParam = (queryParam) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(queryParam);
}

/**
 *
 * @param feature {object} feature
 * @param intl {object} translates provider
 * @param fabricatorData {object} fabricator state
 * @param quantity {number}
 * @param cartItem {cartItemInterface} if passed - return its name (for slabs)
 * @return {string}
 */
export const getFeatureUnit = (feature, intl, fabricatorData, quantity, cartItem = null) => {
  if (cartItem && (cartItem.displayFakeFeatureGroupName === "slabs")) {
    return getSlabUnit(cartItem.displayFakeQuantity, intl)
  }
  const dbFeature = feature.dbFeature;
  if ((fabricatorData.isLowes || fabricatorData.isCaesarStone) && intl.locale === "fr-FR" && intl.messages && intl.messages["transDoc.units_FR." + dbFeature.sharedFeatureName]) {
    if ((intl.formatMessage({id: "transDoc.units_FR." + dbFeature.sharedFeatureName}) === "pieds carrés") && dbFeature.unit === "Each") {
      return quantity === 1 ? "unité" : "nombre unites"
    }
    return intl.formatMessage({id: "transDoc.units_FR." + dbFeature.sharedFeatureName})
  }
  if (dbFeature.unit) {
    let lowercasedUnit = dbFeature.unit.toLowerCase();
    return lowercasedUnit === "each" || lowercasedUnit === "unit"
      ? quantity <= 1
        ? intl.formatMessage({id: "quotingTool.featureInfo.defaultQuantity"})
        : intl.formatMessage({id: "quotingTool.featureInfo.defaultQuantityMultiple"})
      : dbFeature.unit
  }
  if (feature.isStoneFeature) {
    return intl.formatMessage({id: "shoppingCart.fetureInCartDefaultQuantitySQFT"})
  }
  return intl.formatMessage({id: "shoppingCart.fetureInCartDefaultQuantity"})
};

/**
 *
 * @param totalCount {int}
 * @param intl {object} translates provider
 * @return {string}
 */
export const getSlabUnit = (totalCount, intl) => {
  return totalCount === 1
    ? intl.formatMessage({id: "sqftFeaturesPopup.unit.slab"})
    : intl.formatMessage({id: "sqftFeaturesPopup.unit.slabs"})
};

/**
 * @returns {DesignNavigationItem}
 */
export const getSlabsFeatureGroup = (layout = getCurrentLayout()) => {

  const countertopFeatureGroup = getCountertopFeatureGroup(layout);

  // create new featureGroup and add it to qtCategories
  let slabsFeatureGroup = layout.addNonVisualizerSubPart("Slabs");
  if (countertopFeatureGroup) {
    slabsFeatureGroup.part.featuresList = countertopFeatureGroup.featuresList;
    slabsFeatureGroup.part.translateId = 'visualizer.kitchen.slabs';
    slabsFeatureGroup.part.wasCreatedFromGroupName = countertopFeatureGroup.dbName || countertopFeatureGroup.partName;
  }

  return slabsFeatureGroup
}

/**
 * todo: this will add slab featureGroup to each category, we need to check what if qtCategories doesn't match room name
 * add Slabs FeatureGroup To First qtCategory
 * @returns {DesignNavigationItem}
 */
export const getQtCategoriesWithSlabFeatureGroup = (qtCategories) => {
  const state = store.getState();
  const fabricatorSettings = state.fabricatorState.settings;
  if (qtCategories && fabricatorSettings.showSlabMode) {
    const cartItems = state.cartState.cartItems;
    const activeQuoteIndex = state.quotesState.activeQuoteIndex;
    const selectedQuoteRoomCartItem = getCurrentQuoteRoomCartItem(cartItems, activeQuoteIndex);
    const selectedQuoteRoomFeature = selectedQuoteRoomCartItem ? selectedQuoteRoomCartItem.cartFeature : null;
    const activeCategory = qtCategories.find(qtCategory => featureIsMatchingQtCatName(selectedQuoteRoomFeature, qtCategory.name, true));
    let categoryToSearch = activeCategory ? activeCategory : qtCategories[0];
    if (categoryToSearch && !categoryToSearch.subParts.some(subPart => subPart.part.partId === 'slabs')) {
      let subParts = [...categoryToSearch.subParts];
      let slabsFeatureGroup = getSlabsFeatureGroup();
      subParts.push(slabsFeatureGroup);
      qtCategories[qtCategories.findIndex(qtCategory => qtCategory === categoryToSearch)].subParts = subParts;
    }
  }

  return qtCategories
}

/**
 *
 * @param featureGroup {object} featureGroup
 * @param intl {object} translates provider
 * @param fabricatorData {object} fabricator state
 * @return {string}
 */
export const getFeatureGroupName = (featureGroup, intl, fabricatorData) => {
  if (!featureGroup || !intl || !fabricatorData) {
    return ""
  }
  const lowerCasedName = featureGroup.partName.toLowerCase();
  if ((fabricatorData.isLowes || fabricatorData.isCaesarStone) && intl.messages) {
    if (intl.locale === "fr-FR" && intl.messages["transDoc.customDisplayName_FR." + lowerCasedName]) {
      return intl.formatMessage({id: "transDoc.customDisplayName_FR." + lowerCasedName})
    } else if (intl.locale === "pl-PL" && intl.messages["transDoc.customTranslateName_PL." + lowerCasedName]) {
      return intl.formatMessage({id: "transDoc.customTranslateName_PL."  + lowerCasedName})
    }
  }
  if ((intl.locale === "en-US" || fabricatorData.isDeStefano) && featureGroup.customGroupDisplayName) {
    return featureGroup.customGroupDisplayName
  }
  if (featureGroup.partName === "Room") {
    return intl.messages["shoppingCart.roomTitle"]
  }
  if (featureGroup.translateId && intl.messages[featureGroup.translateId]) {
    return intl.messages[featureGroup.translateId]
  }
  switch (featureGroup.partName) {
    case "Installation":
    case "Template":
    case "Tools":
      return intl.messages["visualizer." + featureGroup.partName]
    default:
      return featureGroup.partName
  }
};

/**
 * Each dbFeature should go through this fixes!
 * @param dbFeature {object}
 * @return dbFeature {object}
 */
export const fixDbFeatureProperties = (dbFeature) => {
  dbFeature.metaData = metaDataToCamelCase(dbFeature.metaData); // make all metadata keys CamelCased(dashboard saving issue)
  if (!dbFeature.filterValueIDs) {
    dbFeature.filterValueIDs = {}
  }
  if (!dbFeature.fabFilterValueIDs) {
    dbFeature.fabFilterValueIDs = {}
  }
  if (dbFeature.sharedFeatureName) {
    dbFeature.sharedFeatureName = dbFeature.sharedFeatureName.trim();
    // if (!dbFeature.sku) {
    //   dbFeature.sku = dbFeature.sharedFeatureName // bvLook visualizer only has shared feature names, not the sku :(
    // }
  }
  if (!dbFeature.displayName) {
    dbFeature.displayName = dbFeature.sharedFeatureName;
    // if (!dbFeature.sku) {
    //   dbFeature.sku = dbFeature.sharedFeatureName // bvLook visualizer only has shared feature names, not the sku :(
    // }
  }
  return dbFeature
}

/**
 * @param forFeature {featureInterface}
 * @param fabricatorSettings {object}
 * @param checkArray {array}
 * @return {boolean}
 */
export const canShowSqftButtonForFeature = (forFeature, fabricatorSettings, checkArray = null) => {
  if (!checkArray) {
    checkArray = [...Object.keys({...COUNTERTOP_LABELS, ...EDGE_LABELS, ...BACKSPLASH_LABELS, ...CORNER_LABELS}), ...LOOK_WALLS_ONLY];
  }

  const canShowForCommonIds = checkArray.includes(forFeature.partId) || (
    forFeature.dbFeature && (forFeature.dbFeature.sharedFeatureName === "Xtone Underlayment") // porcelanosa hardcode, but can be used for all
    && checkArray.some(key => key === "center_island_countertop") // show it only once, cabinets check
  )

  switch (getCommonVisualizerType()) {
    case "bathroom": {
      if (fabricatorSettings.enableSqFt) { // fabricatorSettings.enableSqFt - is actually disable
        return false
      }
      return canShowForCommonIds
    }
    case "fireplace": { // enableSqFt doesn't work on the fireplace profile omg
      return canShowForCommonIds
    }
    case "kitchen":
    default: { // remove default as we have fireplace or other visualizer ready
      if (fabricatorSettings.enableSqFt) { // fabricatorSettings.enableSqFt - is actually disable
        return false
      }
      return canShowForCommonIds
    }
  }
}

/**
 * @param forFeature {featureInterface}
 * @param fabricatorSettings {object}
 * @return {boolean}
 */
export const canShowSqftCabinetButtonForFeature = (forFeature, fabricatorSettings) => {
  return isCabinetsFabricator()
    || canShowSqftButtonForFeature(forFeature, fabricatorSettings, Object.keys({...CABINET_LABELS, ...CABINET_BATHROOM_LABELS}))
}

/**
 * @return {boolean}
 */
export const canShowSqftButton = () => {
  const fabricatorSettings = store.getState().fabricatorState.settings;

  if (document.kvConfig.userId === 238280) { // solid surface
    return true
  }

  return (document.kvConfig.visualizerType === "Kitchen" || document.kvConfig.visualizerType === "KV" || fabricatorSettings.useCategorySwitching)
    && !fabricatorSettings.enableSqFt; // fabricatorSettings.enableSqFt - is actually disable
}

/**
 *
 * @param fromFeature {featureInterface}
 * @param newQuantity {number}
 * @param qtActiveCategory {string}
 * @return {cartItemInterface}
 */
export const getCartItemObject = (fromFeature, newQuantity, qtActiveCategory) => {
  const subPart = fromFeature.getParent();
  const parentName = subPart.getParent ? subPart.getParent().partName : subPart.partName
  const cartItemObject = {
    selectionGroup: parentName,
    quantity: newQuantity,
    partId: fromFeature.partId,
    cartFeature: fromFeature,
  }
  // if (fromFeature.inCatProperties) { // added always, to properly switch to feature group and category from cart
  cartItemObject.fromQtCategory = qtActiveCategory
  // }
  return cartItemObject
}

/**
 *
 * @param relatedFeatures {array} feature relatedFeatures array
 * @param currentFeature {object} feature
 * @param searchInputValue
 * @return {object}
 */
export const getRelatedFeaturesFromLayout = (relatedFeatures, currentFeature, searchInputValue = "", selectedFilters = []) => {
  const layout = getCurrentLayout();
  const parentParts = Object.values(layout.parts);
  let relatedFeaturesFound = [];
  let noFeaturesFound = [];
  if (!Array.isArray(relatedFeatures)) {
    return {noFeaturesFound, relatedFeaturesFound}
  }
  relatedFeatures.forEach(relatedFeature => {
    let featureIsFound = false;
    let groupName = relatedFeature.groupName;
    if (!groupName) {
      groupName = splitFeatureName(relatedFeature.displayName).groupName;
    }
    groupName = groupName.toLowerCase().trim();
    parentParts.forEach(parentPart => {
      parentPart.relatedItems.forEach(relItem => {
        let edgeCondition = true;
        const dbName = (relItem.dbName || relItem.partName).toLowerCase().trim();
        // 157699 - hardcode for stone_industries_pan.quotekitchenandbath.com/kitchen - they have back countertop & center island edge
        if (groupName === "edge profile" && (document.kvConfig.userId !== 157699) && (relItem.partId !== currentFeature.partId)) {
          edgeCondition = false; // take edge only for countertop || center_island_countertop
        }
        if ((dbName === groupName) && edgeCondition) {
          let feature = null;
          Object.keys(relItem.featuresList).forEach(layoutType => {
            feature = feature || relItem.featuresList[layoutType].find(feature => {
              return feature.dbFeature.id === relatedFeature.id;
            })
          });
          if (feature) {
            if (searchInputValue !== "") {
              if (feature.getFeatureName().toLowerCase().includes(searchInputValue.trim().toLowerCase())
                || (feature.dbFeature && feature.dbFeature.description && feature.dbFeature.description.toLowerCase().includes(searchInputValue.trim().toLowerCase()))
              ) {
                relatedFeaturesFound.push(feature);
                featureIsFound = true;
              }
            } else {
              relatedFeaturesFound.push(feature);
              featureIsFound = true;
            }
          }
        }
      })
    });
    if (!featureIsFound) {
      noFeaturesFound.push(relatedFeature.id)
    }
    relatedFeaturesFound = filterFeaturesByValues(relatedFeaturesFound, selectedFilters);
  });
  return {noFeaturesFound, relatedFeaturesFound}
}

export const getFilteredRelatedFeatures = (relatedFeaturesToCheck) => {
  // console.log("relatedFeaturesToCheck", relatedFeaturesToCheck);
  let relatedFeatures = [];
  relatedFeaturesToCheck.forEach((relFeature) => {
    const featureAlreadyExistIndex = relatedFeatures.findIndex(currentFeature => {
      return currentFeature.getSplittedFeatureName() === relFeature.getSplittedFeatureName()
    })
    if (featureAlreadyExistIndex > -1) {
      if (relFeature.getParent().navigationSubItems().some(navItem => {
        return navItem.part.dbFeature.id === relFeature.dbFeature.id
      })) {
        relatedFeatures.splice(featureAlreadyExistIndex, 1, relFeature)
      }
    } else {
      relatedFeatures.push(relFeature);
    }
  });
  // console.log("relatedFeatures", relatedFeatures);
  return relatedFeatures
};

/**
 *
 * @param relatedFeatures {array} feature relatedFeatures array
 * @param cartItems {array} cartItems array
 * @param quoteIndex {number} quoteIndex
 * @param intl {object} react-intl instance
 * @param fabricatorData {object}
 * @return {array}
 */
export const createRelatedGroups = (relatedFeatures, cartItems, quoteIndex, intl, fabricatorData) => {
  const relatedGroups = [];
  relatedFeatures.forEach(relatedFeature => {
    const addedCartItem = cartItems.find(cartItem => {
      return cartItem.cartFeature && (cartItem.cartFeature.dbFeature.id === relatedFeature.dbFeature.id)
        && cartItem.currentQuote === quoteIndex
    })
    relatedFeature.cartQuantity = addedCartItem ? addedCartItem.quantity : 0;
    const relatedFeatureGroupName = getFeatureGroupName(relatedFeature.getParent(), intl, fabricatorData);
    const featureGroup = relatedGroups.find(group => group.name === relatedFeatureGroupName);
    if (!featureGroup) {
      const name = relatedFeature.getParent
        ? relatedFeatureGroupName
        : relatedFeature.dbFeature.groupName
      relatedGroups.push({
        name,
        relatedFeatures: [relatedFeature]
      })
    } else {
      featureGroup.relatedFeatures.push(relatedFeature);
    }
  });
  return relatedGroups
}

/**
 *
 * @param filterGroup {object}
 * @return {array}
 */
export const getAllFilterGroupValuesFromGroup = (filterGroup) => {
  const fValues = [];
  if (!filterGroup || !filterGroup.values) {
    return []
  }
  filterGroup.values.forEach(fValue => {
    fValues.push(fValue);
    if (Array.isArray(fValue.items) && fValue.items.length) {
      fValue.items.forEach(childValue => {
        fValues.push(childValue);
      });
    }
  });
  return fValues
};

/**
 *
 * @param websiteUrl {string}
 */
export const goToFabricatorUrl = (websiteUrl) => {
  websiteUrl = websiteUrl.includes("http") ? websiteUrl : "//" + websiteUrl;
  if (isIframe()) {
    window.parent.location.href = websiteUrl;
  } else {
    window.location.href = websiteUrl;
  }
}
